import { mapGetters } from 'vuex';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';

/**
 * 라우트 쿼리의 userAccountId를 accountId와 동기화하는 observeUserAccountIdQuery$
 * 메서드를 제공하는 믹스인. 구독 시작 시점은 사용하는 컴포넌트가 정한다.
 * - userAccountId가 없으면 accountId 값으로 채운다 (디버깅 목적)
 * - admin이 아니면 accountId와 다른 userAccountId를 쓸 수 없다
 */
export default {
    computed: {
        ...mapGetters('user', ['isAdmin']),
    },
    methods: {
        observeUserAccountIdQuery$() {
            const query$ = this.generateWatchNew$('$route.query', {
                deep: true,
            }).pipe(distinctUntilChanged(R.equals), shareReplay(1));

            this.$subscribeTo(query$, (query) => {
                let userAccountIdFromQuery = query.userAccountId;

                if (userAccountIdFromQuery == 0) {
                    userAccountIdFromQuery = undefined;
                }
                if (
                    // fill userAccountId if not exist for debugging purpose
                    (!userAccountIdFromQuery && query.accountId) ||
                    // if user is not admin, can not use other userAccountId
                    (!this.isAdmin &&
                        userAccountIdFromQuery !== query.accountId)
                ) {
                    this.$router.replace({
                        query: R.assoc('userAccountId', query.accountId, query),
                    });
                }
            });
        },
    },
};
